import Categories from "../../../practice/variables/Categories";
import PracticeAnalysisQuestions from "../../../../../utils/pratice-analysis-quesstions";


export default function getPracticeAnalysisFilter() {
    let options = []
    Object.keys(Categories).forEach((category) => {
        for (let i = 0; i < Categories[category].options.length; i++) {
            let option = Categories[category].options[i]
            if (PracticeAnalysisQuestions.includes(option.value)) {
                options.push(option)
            }
        }
    })
    return {
        title: "Type",
        options: options
    }
}